import React from "react";
import { Badge, Tooltip } from "../../../components/ui";

/* ────────────────────────────────────────────────────────────
 * RowBadge — a sidebar row's red count pill, with a hover bubble
 * that says what the number counts (QA NAV-2: "It isn't clear what
 * 171 counts").
 *
 * `hint` comes from the row's `badgeHint` in sidebarMenuConfig.js,
 * via resolveBadgeHint. Without one this renders exactly the Badge it
 * replaces. The Tooltip wrapper carries `sb-sidebar__row-badge` too,
 * so the collapsed icon strip still hides the badge and the phone
 * drawer still shows it (sidebar.scss).
 *
 * The badge sits inside the row's link / button and can't take focus,
 * so the bubble is for pointer users; a visually hidden copy of the
 * hint gives screen-reader users the same words with the row's name.
 * ──────────────────────────────────────────────────────────── */

export const resolveBadgeHint = (entry, value, counters) => {
  const hint = entry ? entry.badgeHint : null;
  if (typeof hint === "function") return hint(value, counters || {});
  return hint || null;
};

const RowBadge = ({ value, hint }) => {
  const pill = (
    <Badge variant="danger" size="sm" className="sb-sidebar__row-badge">
      {value}
    </Badge>
  );
  if (!hint) return pill;
  // The bubble is for the pointer; a screen reader gets the same words as
  // part of the row's name instead of the bare number.
  return (
    <>
      <Tooltip content={hint} className="sb-sidebar__row-badge">
        <span aria-hidden="true">{pill}</span>
      </Tooltip>
      <span className="visually-hidden">{`, ${hint}`}</span>
    </>
  );
};

export default RowBadge;
